import WinlosesTypes from './types';
import { ManagersWinlosesState, ManagersWinlosesDispatchAction } from './state';
import { Reducer } from 'redux';

const initialState: ManagersWinlosesState = {
    wins: '',
    loses: '',
    avg: 0,
    perfect : '-',
    percent : 0,
    touch: 0,
    chefmet : 0
}

export const WinlosesReducer : Reducer<ManagersWinlosesState, ManagersWinlosesDispatchAction>= 
    (state = initialState, action) => {
        switch(action.type) {
            case WinlosesTypes.FETCH_START:
                return state
            case WinlosesTypes.FETCH_SUCCESS:
                return action.payload
            default:
                return state
        }
    }

export default WinlosesReducer;